import { render, staticRenderFns } from "./DescriptionPanel.vue?vue&type=template&id=5cfcefe1&scoped=true"
import script from "./DescriptionPanel.vue?vue&type=script&lang=js"
export * from "./DescriptionPanel.vue?vue&type=script&lang=js"
import style0 from "./DescriptionPanel.vue?vue&type=style&index=0&id=5cfcefe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfcefe1",
  null
  
)

export default component.exports